  
export var completeConfig =
  {
    "env": "TEST",
  }

export default completeConfig